import { createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk";
import { rootReducer } from "./rootReducer"
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist"
import storageSession from "redux-persist/lib/storage/session"

//storageSession.removeItem("persist:root");

const persistConfig = {
    key: "root",
    storage: storageSession
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const appStore = createStore(
    persistedReducer,
    composeWithDevTools((applyMiddleware(thunk)))
);

export const persistor = persistStore(appStore);
export default appStore;